// Etsy kargo profilleri — magaza basina liste + kararli renk.
//
// Listing Builder satirindaki etiket ve Liste Denetimi'ndeki coklu secim ayni
// listeyi ve ayni renkleri kullanir: bir profil her ekranda ayni renkte gorunur.

import { useQueries, useQuery } from "@tanstack/react-query";
import { authHeaders, getBackendUrl } from "./http";

export type ShippingProfile = { id: string; title: string };

async function fetchProfiles(shopId: string | null): Promise<ShippingProfile[]> {
  const res = await fetch(`${getBackendUrl()}/api/etsy/listings/shipping-profiles/list`, {
    // Baska magazanin profilleri: istek o magaza adina yapilir
    headers: authHeaders(shopId ? { "X-Shop-Id": shopId } : undefined),
  });
  if (!res.ok) return [];
  const j = await res.json().catch(() => ({}));
  const rows = (j.data?.results ?? j.results ?? []) as Array<Record<string, unknown>>;
  return rows.map((x) => ({ id: String(x.shipping_profile_id), title: String(x.title ?? x.shipping_profile_id) }));
}

const query = (shopId: string | null) => ({
  queryKey: ["shipping-profiles", shopId ?? "active"],
  queryFn: () => fetchProfiles(shopId),
  staleTime: 10 * 60 * 1000,
});

/** Aktif (ya da verilen) magazanin kargo profilleri */
export function useShippingProfiles(shopId: string | null = null) {
  return useQuery(query(shopId)).data ?? [];
}

/** Birden fazla magazanin kargo profilleri: shopId -> liste */
export function useShippingProfilesByShop(shopIds: string[]) {
  const results = useQueries({ queries: shopIds.map((id) => query(id)) });
  const map: Record<string, { profiles: ShippingProfile[]; loading: boolean }> = {};
  shopIds.forEach((id, i) => { map[id] = { profiles: results[i]?.data ?? [], loading: !!results[i]?.isLoading }; });
  return map;
}

// Tailwind siniflari sabit metin olmali (JIT tarar)
const PALETTE = [
  "bg-sky-100 text-sky-800 border-sky-200",
  "bg-violet-100 text-violet-800 border-violet-200",
  "bg-amber-100 text-amber-800 border-amber-200",
  "bg-emerald-100 text-emerald-800 border-emerald-200",
  "bg-rose-100 text-rose-800 border-rose-200",
  "bg-teal-100 text-teal-800 border-teal-200",
  "bg-orange-100 text-orange-800 border-orange-200",
  "bg-indigo-100 text-indigo-800 border-indigo-200",
  "bg-lime-100 text-lime-800 border-lime-200",
  "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
];

/** Profilin rengi: kimlikten turetilir, her ekranda ve her yuklemede ayni */
export function shippingProfileColor(id: string | null | undefined): string {
  if (!id) return "bg-gray-100 text-gray-500 border-gray-200";
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
